import Vue from 'vue'
import Router from 'vue-router'
import MainFrame from './frame/MainFrame.vue'
import SimpleFrame from './frame/SimpleFrame.vue'
import Home from './views/Home3.vue'
import store from './store'
import { auth } from '@/main'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: MainFrame,
      children:[
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: {pageName: 'ホーム'}
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('./views/About.vue'),
          meta: {pageName: 'カライモノタベタイとは？'}
        },
        {
          path: '/kiyaku',
          name: 'kiyaku',
          component: () => import('./views/Kiyaku.vue'),
          meta: {pageName: '利用規約'}
        },
        {
          path: '/info',
          name: 'UserInfoView',
          component: () => import('./views/UserInfoView.vue'),
          meta: {pageName: '利用規約'}
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/auth/Login.vue')
        },
        {
          path: '/login/passwordReset',
          name: 'LoginPasswordReset',
          component: () => import('./views/auth/LoginPasswordReset.vue')
        },
        {
          // only login user
          path: '/editFood',
          name: 'editFood',
          component: () => import('./views/EditFood.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          path: '/editFood/update',
          name: 'updateFood',
          component: () => import('./views/EditFood.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          path: '/editShop/:shop',
          name: 'editShop',
          component: () => import('./views/EditShop.vue'),
          meta: {requiresAuth: true}
        },
        {
          path: '/search',
          name: 'searchFood',
          component: () => import('./views/FoodSearchAlgolia.vue'),
          meta: {pageName: '食品検索'}
        },
        {
          path: '/food/:id',
          name: 'searchFoodDetail',
          component: () => import('./views/FoodDetail.vue'),
          meta: {pageName: '食品ページ'}
        },
        {
          // OGP用
          path: '/_food/:id',
          redirect : '/food/:id'
        },
        {
          // only login user
          // カラログ登録前の食品検索画面
          path: '/post/search/food',
          name: 'reviewPostSearchFood',
          component: () => import('./views/ReviewPostFoodSearchView.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          // カラログ編集
          path: '/post/edit/:id',
          name: 'reviewEdit',
          component: () => import('./views/ReviewPostEdit.vue'),
          meta: {requiresAuth: true}
        },
        {
          path: '/reviews',
          name: 'searchReview',
          component: () => import('./views/ReviewSearch.vue'),
          meta: {pageName: 'みんなの投稿'}
        },
        {
          path: '/review/:id',
          name: 'searchReviewDetail',
          component: () => import('./views/ReviewDetail.vue'),
          meta: {pageName: '投稿ページ'}
        },
        {
          // OGP用
          path: '/_review/:id',
          redirect : '/review/:id'
        },
        {
          path: '/user/:id',
          name: 'UserTop',
          component: () => import('./views/UserTop.vue'),
          meta: {pageName: 'マイページ'}
        },
        {
          path: '/user/edit',
          name: 'UserProfileEdit',
          component: () => import('./views/UserEdit.vue'),
          meta: {requiresAuth: true, pageName: 'プロフィール更新'}
        },
        {
          // only login user
          path: '/signup/edit',
          name: 'UserProfileEditInit',
          component: () => import('./views/UserEditInit.vue'),
          meta: {requiresAuth: true, pageName: 'プロフィール更新'}
        },
        {
          // only login user
          path: '/signup/karasa',
          name: 'karasaInit',
          component: () => import('./views/KarasaInit.vue'),
          meta: {requiresAuth: true, pageName: '辛さ設定'}
        },
        {
          path: '/shop',
          name: 'searchShops',
          component: () => import('./views/ShopSearch.vue'),
          meta: {pageName: '飲食店・レストラン検索'}
        },
        {
          path: '/shop/:id',
          name: 'ShopDetail',
          component: () => import('./views/ShopDetail.vue'),
          meta: {pageName: '飲食店詳細ページ'}
        },
        // {
        //   path: '/magazin',
        //   name: 'MagazinList',
        //   component: () => import('./magazin/MagazinList.vue')
        // },
        // {
        //   path: '/magazin/:id',
        //   name: 'MagazinArticle',
        //   component: () => import('./magazin/MagazinArticle.vue')
        // }
        {
          path: '/news',
          name: 'NewsList',
          component: () => import('./news/NewsList.vue')
        },
        {
          path: '/news/:newsId',
          name: 'NewsView',
          component: () => import('./news/NewsView.vue'),
          meta: {pageName: 'ニュース記事ページ'}
        }
      ]
    },
    {
      path: '/edit',
      component: SimpleFrame,
      children:[
        {
          // only login user
          path: '/RankEdit',
          name: 'RankEdit',
          component: () => import('./views/RankEdit.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          path: '/post',
          name: 'reviewPostView',
          component: () => import('./views/ReviewPostView.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          // カラログ登録時に食品も同時に登録する
          path: '/post/free',
          name: 'reviewPostViewWithFood',
          component: () => import('./views/ReviewPostView.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          // 食品なしでカラログ登録する
          path: '/post/noFood',
          name: 'reviewPostViewNoFood',
          component: () => import('./views/ReviewPostViewMin.vue'),
          meta: {requiresAuth: true}
        },
        {
          // only login user
          // 飲食店にカラログ登録する
          path: '/post/shop',
          name: 'reviewPostViewShop',
          component: () => import('./views/ReviewPostViewShop.vue'),
          meta: {requiresAuth: true}
        }
      ]
    }
  ]
})

router.afterEach((to) => {
  store.commit('pushPageTransition', to)
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          name: 'login',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else {
    next()
  }
})

export default router